import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import { displayField, displayYesNo } from "../../../utils/helpers";

const ChartInfoCell = ({
  dataKey,
  rowData,
  onClick,
  ...props
}: {
  dataKey?: string;
  rowData: any;
  onClick?: Function;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  const speaker = (
    <Popover title={t("CHART") + "-" + rowData.chart_title}>
      <p>
        <b>{t("NAME")} : </b>
        {displayField(rowData.chart_title)}
      </p>
      {rowData.license_name && (
        <p>
          <b>{t("LICENSE")} : </b>
          {displayField(rowData.license_name)}
        </p>
      )}

      {rowData.chart_type && (
        <p>
          <b>{t("TYPE")} : </b>
          {displayField(rowData.chart_type)}
        </p>
      )}

      {rowData.event_name && (
        <p>
          <b>{t("EVENT")} : </b>
          {displayField(rowData.event_name)}
        </p>
      )}

      {rowData.company_name && (
        <p>
          <b>{t("COMPANY")} : </b>
          {displayField(rowData.company_name)}
        </p>
      )}

      {!rowData.company_name && rowData.chart_for != "public" && (
        <p>
          <b>
            {t("FOR")} {t("ALL")} {t("COMPANY")} :{" "}
          </b>
          {displayYesNo(rowData.for_all_company)}
        </p>
      )}
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a
          onClick={() => {
            onClick && onClick(rowData);
          }}
        >
          {displayField(rowData.chart_title)}
          <br />
          {rowData.total_songs} {rowData.license_name} {t("SONGS")}
        </a>
      </Whisper>
    </Cell>
  );
};

export default ChartInfoCell;
